import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
  align-items: center;
  justify-content: center;
`;

export const AppName = styled.div`
  display: flex;
  flex-direction: column;
  margin: -100px 0 100px 0;
  gap: 5px;

  h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 24px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray0};
  }

  h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray0};
  }
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;
